import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { DoctorsService } from 'src/app/shared/doctor-service/doctors.service';
import { take } from 'rxjs/operators';
import * as moment from 'moment';
@Component({
  selector: 'app-member-record',
  templateUrl: './member-record.component.html',
  styleUrls: ['./member-record.component.css']
})
export class MemberRecordComponent implements OnInit {
  startDate: any;
  endDate: any;
  memberName:any;
  clinicName:any;
  memberId:any;
  token:any;
  moment= moment;
  data = [
    { date: new Date('2023-10-10'), value: 100 },
    { date: new Date('2023-10-15'), value: 150 },
    { date: new Date('2023-10-20'), value: 200 },
    { date: new Date('2023-10-25'), value: 250 },
  ];
  appointments:any =[];
  

  filteredData: any[];
  constructor(
    private route: ActivatedRoute,
    private docservice:DoctorsService,
    private authService:AuthService
    ) { }

  ngOnInit(): void {
    
    this.route.params.subscribe(params => {
      this.startDate = params['startDate'];
      this.endDate = params['endDate'];
      this.memberId = params['id'];
      this.filterDataByDateRange();
      this.authService.authDataSubject.pipe(take(1)).subscribe((auth) => {
        this.token = auth._token;
        this.getAppoinmentData();
      }); 
    });

  }
  filterDataByDateRange() {
    if (this.startDate && this.endDate) {
      this.filteredData = this.data.filter(item => {
        const itemDate = new Date(item.date);
        return itemDate >= this.startDate && itemDate <= this.endDate;
      });
    } else {
      this.filteredData = [];
    }
  }
  getAppoinmentData(){
    let postData = {
      startDate:this.startDate,
      endDate:this.endDate,
      memberId:this.memberId
    }
    this.docservice.getmemberAmountByDateRange(postData,this.token).subscribe((res:any)=>{
      console.log("this is response ",res);
      this.appointments =  res.list;
      this.memberName = res.member.name;
      this.clinicName = res.member.clinicId.clinicName;
    })
  }

}
